import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type ThemeMode = 'light' | 'dark' | 'system'
type Language = 'en' | 'es' | 'fr' | 'de' | 'it' | 'ca' | 'eu'
type LaunchMode = 'native' | 'html5'
type IconSize = 'large' | 'small'

interface PreferencesState {
  themeMode: ThemeMode
  language: Language
  launchMode: LaunchMode
  appIconSize: IconSize
  favoriteAppIds: string[]
  setThemeMode: (mode: ThemeMode) => void
  setLanguage: (lang: Language) => void
  setLaunchMode: (mode: LaunchMode) => void
  setAppIconSize: (size: IconSize) => void
  toggleFavorite: (appId: string) => void
  isFavorite: (appId: string) => boolean
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set, get) => ({
      themeMode: 'system',
      language: 'es',
      launchMode: 'native',
      appIconSize: 'large',
      favoriteAppIds: [],

      setThemeMode: (mode) => set({ themeMode: mode }),
      setLanguage: (lang) => set({ language: lang }),
      setLaunchMode: (mode) => set({ launchMode: mode }),
      setAppIconSize: (size) => set({ appIconSize: size }),

      toggleFavorite: (appId) => {
        const ids = get().favoriteAppIds
        if (ids.includes(appId)) {
          set({ favoriteAppIds: ids.filter((id) => id !== appId) })
        } else {
          set({ favoriteAppIds: [...ids, appId] })
        }
      },

      isFavorite: (appId) => get().favoriteAppIds.includes(appId),
    }),
    {
      name: 'flexilabs_prefs',
    }
  )
)
